import { CARNIVAL_UI } from "../lib/carnivalMeta";

// Small inline pill next to each carnival date. Two variants:
//   • confirmed → solid teal, reads "Confirmed · SMAC"
//   • estimated → amber outline, reads "Estimated · Pending official schedule"
// Kept as a stateless leaf component with no internal i18n — it reads
// localized strings from `CARNIVAL_UI` and takes `lang` as a prop so the
// parent page owns the language state (matches the rest of the app's
// t()-via-context pattern).

export const CarnivalStatusBadge = ({ status, source, lang }) => {
  const l = lang || "en";
  if (status === "confirmed") {
    const label = CARNIVAL_UI.status_confirmed[l] || CARNIVAL_UI.status_confirmed.en;
    return (
      <span
        data-testid="carnival-status-confirmed"
        style={{
          display: "inline-flex",
          alignItems: "center",
          gap: 4,
          fontSize: 11,
          fontWeight: 600,
          background: "#0AADA0",
          color: "#FFFFFF",
          padding: "2px 8px",
          borderRadius: 999,
          letterSpacing: "0.01em",
          whiteSpace: "nowrap",
        }}
      >
        <span aria-hidden style={{ fontSize: 10 }}>✓</span>
        {label}
        {source ? <span style={{ opacity: 0.85 }}>· {source}</span> : null}
      </span>
    );
  }
  // Estimated
  const label = CARNIVAL_UI.status_estimated[l] || CARNIVAL_UI.status_estimated.en;
  const note  = CARNIVAL_UI.status_estimated_note[l] || CARNIVAL_UI.status_estimated_note.en;
  return (
    <span
      data-testid="carnival-status-estimated"
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 4,
        fontSize: 11,
        fontWeight: 600,
        background: "#FFFFFF",
        color: "#B45309",
        border: "1px solid #F59E0B",
        padding: "2px 8px",
        borderRadius: 999,
        letterSpacing: "0.01em",
        whiteSpace: "nowrap",
      }}
    >
      <span aria-hidden style={{ fontSize: 10 }}>~</span>
      {label}
      <span style={{ opacity: 0.75, fontWeight: 500 }}>· {note}</span>
    </span>
  );
};
